import { StateUpdaterMap } from "src/model/manager/state-manager";
import appState, { AppState } from "..";

export interface ModalManagerActions {
  CATEGORY_FILTER_BAR_HANDLER?: boolean;
  PRODUCT_FILTER_BAR_HANDLER: boolean;
  BUNDLES_FILTER_BAR_HANDLER?: boolean;
}

export const useCategoryFilterHandler = () => appState.execute("CATEGORY_FILTER_BAR_HANDLER", !appState.get().modals.categoryFilter);
export const useProductFilterHandler = () => appState.execute("PRODUCT_FILTER_BAR_HANDLER", !appState.get().modals.productFilter);
export const useBundlesFilterHandler = () => appState.execute("BUNDLES_FILTER_BAR_HANDLER", !appState.get().modals.bundlesFilter);


export const modalManagerActions: StateUpdaterMap<
  AppState,
  ModalManagerActions
> = {
  CATEGORY_FILTER_BAR_HANDLER: (open, prevState) => ({
    modals: {
      ...prevState.modals,
      categoryFilter: open,
    },
  }),
  PRODUCT_FILTER_BAR_HANDLER: (open, prevState) => ({
    modals: {
      ...prevState.modals,
      productFilter: open,
    },
  }),
  BUNDLES_FILTER_BAR_HANDLER: (open, prevState) => ({
    modals: {
      ...prevState.modals,
      bundlesFilter: open,
    },
  }),
};
